import * as CryptoJS from "crypto-js";

const STORAGE_KEY_PREFIX = 'wc2:';
const VALUE_PREFIX = 'v2';
const IV_HEX_LENGTH = 32;

const encKey = () => CryptoJS.enc.Base64.parse("#base64Key#");
/** Fixed IV from the previous storage format; used only to find and remove entries written before this change. */
const legacyIv = () => CryptoJS.enc.Base64.parse("#base64IV#");

export const toStorageKey = (key: string): string =>
  STORAGE_KEY_PREFIX + CryptoJS.SHA256(key).toString(CryptoJS.enc.Hex);

export const encryptStorageValue = (value: any): string => {
  const iv = CryptoJS.lib.WordArray.random(16);
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), encKey(), { iv }).toString();
  return VALUE_PREFIX + iv.toString(CryptoJS.enc.Hex) + ciphertext;
};

export const decryptStorageValue = (stored: string | null): any => {
  if (!stored || !stored.startsWith(VALUE_PREFIX)) return null;
  try {
    const iv = CryptoJS.enc.Hex.parse(stored.substr(VALUE_PREFIX.length, IV_HEX_LENGTH));
    const plaintext = CryptoJS.AES.decrypt(stored.substring(VALUE_PREFIX.length + IV_HEX_LENGTH), encKey(), { iv }).toString(CryptoJS.enc.Utf8);
    return plaintext && plaintext.length ? JSON.parse(plaintext) : null;
  } catch (err) {
    return null;
  }
};

/** Returns the original key name if `storedKey` was produced by the previous format, otherwise null. */
const legacyKeyName = (storedKey: string): string | null => {
  try {
    const name = CryptoJS.AES.decrypt(storedKey, encKey(), { iv: legacyIv() }).toString(CryptoJS.enc.Utf8);
    if (!name) return null;
    const reencrypted = CryptoJS.AES.encrypt(name, encKey(), { iv: legacyIv() }).toString();
    return reencrypted === storedKey ? name : null;
  } catch (err) {
    return null;
  }
};

export const purgeLegacyEntries = (storage: Storage): void => {
  const storedKeys: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const storedKey = storage.key(i);
    if (storedKey && !storedKey.startsWith(STORAGE_KEY_PREFIX)) storedKeys.push(storedKey);
  }
  storedKeys.filter((storedKey) => legacyKeyName(storedKey) !== null).forEach((storedKey) => storage.removeItem(storedKey));
};
